import api from '@/lib/axios'

export interface Notification {
  id: string
  userId: string
  type: string
  title: string
  body: string
  data?: Record<string, any>
  isRead: boolean
  readAt?: string | null
  channel: string
  sentAt?: string | null
  createdAt: string
}

export interface NotifListResponse {
  data: Notification[]
  meta: { total: number; page: number; limit: number; totalPages: number }
}

const BASE = '/notifications'
const res = <T>(r: any): T => r.data?.data ?? r.data

export const notificationsApi = {
  list: (params?: { page?: number; limit?: number; isRead?: boolean }) =>
    api.get<NotifListResponse>(BASE, { params }).then(res),

  unreadCount: () =>
    api.get<{ count: number }>(`${BASE}/unread-count`).then(res),

  markAsRead: (id: string) =>
    api.patch(`${BASE}/${id}/read`).then(res),

  markAllAsRead: () =>
    api.patch(`${BASE}/read-all`).then(res),

  remove: (id: string) =>
    api.delete(`${BASE}/${id}`).then(res),

  // Sprint 3 — Préférences notifications
  getPreferences: () =>
    api.get(`${BASE}/preferences`).then(res),
  updatePreferences: (dto: any) =>
    api.patch(`${BASE}/preferences`, dto).then(res),
}
